<template>
    <section>
        <div class="container" v-if="hasPermission">
            <h2 class="font-medium text-md">{{translate('timeline')}}</h2>
        </div>
        <wrapper v-if="hasPermission && !!model"></wrapper>
        <div v-else class="container">
            <no-access :sub-page="SubPage.TIMELINE"></no-access>
        </div>
    </section>
</template>

<script lang="ts">
import {useDetailStore} from "../store";
import {SubPage, TimelineModel} from "../types";
import {defineComponent} from 'vue';
import NoAccess from "./no-access.vue";
import {Feature} from "../../../types/dto/Feature";
import Wrapper from "./timeline/wrapper.vue";

export default defineComponent({
    name: "timeline",
    components: {NoAccess, Wrapper},
    data() {
        return {
            detailStore: useDetailStore(),
            SubPage
        }
    },
    computed: {
        hasPermission(): boolean {
            return this.detailStore.canSeePaidComponents && this.detailStore.permissions[Feature.TIMELINE];
        },
        model(): TimelineModel | null {
            return this.detailStore.pageModel[SubPage.TIMELINE];
        },
    }
});
</script>

